import React from "react";
import { Route, useParams } from "react-router-dom";
import Quotation from "../../pages/quotation";
import PrivateRoute from "../../PrivateRoute";

export const quotation = (
  <>
    <Route path="/quotation" element={<PrivateRoute><Quotation /></PrivateRoute>} />
  </>
);
